import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { DateOfInsuranceOnboard, DateOfInsuranceReserve } from '../../../../item/ItemCustomerPosition';
import { uuid } from '../../../../item/ItemTools';
import { EnableBadge, DisableBadge, AddButton, Space, DeleteButton, RefuseButton } from '../../Res/BaseButton';
import { Pagination } from '../../Res/Pagination';
import moment from 'moment';
import { SingleSelect, SingleCheckBox, SingleText } from '../../Res/BaseInput';
import { DatePickerInput } from 'rc-datepicker';
import { RespInsuranceListItem, INSURANCE_STATUS_REFUSE } from '../../../../item/ItemInsurance';

export function HealthInsuranceEnrollSOP({ isEnroll, list, count, page, sp, oc, tc, action, laborInsuranceLevel_Arr, healthInsuranceLevel_Arr }) {
    const [insuranceList, setInsuranceList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    const [overdueCount, setOverdueCount] = useState(0)
    const [todayCount, setTodayCount] = useState(0)

    const [chooseAll, setChooseAll] = useState(false)
    const [insuranceListView, setInsuranceListView] = useState(<></>)

    useEffect(() => {
        if (list !== undefined && list !== insuranceList) {
            setInsuranceList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
        }
    }, [list])

    useEffect(() => {
        // console.log(count)
        if (count !== undefined && count !== mCount)
            setCount(count)
    }, [oc])

    useEffect(() => {
        // console.log(oc)
        if (oc !== undefined && oc !== overdueCount)
            setOverdueCount(oc)
    }, [oc])

    useEffect(() => {
        if (tc !== undefined && tc !== todayCount)
            setTodayCount(tc)
    }, [tc])

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    function toAdd() {
        var filterEmpty = JSON.parse(JSON.stringify(insuranceList))
        var itemListTemp = []
        filterEmpty.map(obj => {
            if (obj.isChoose) {
                var insurance = obj.insurance
                insurance.insuranceInfo = JSON.stringify(insurance.insuranceInfo)
                itemListTemp.push(insurance)
            }
        })
        // console.log(itemListTemp)
        action(itemListTemp)
    }

    function toDel() {
        var filterEmpty = JSON.parse(JSON.stringify(insuranceList))
        var itemListTemp = []
        filterEmpty.map(obj => {
            if (obj.isChoose) {
                var insurance = obj.insurance
                insurance.insuranceInfo.healthInsurance.status = INSURANCE_STATUS_REFUSE
                insurance.insuranceInfo = JSON.stringify(insurance.insuranceInfo)
                itemListTemp.push(insurance)
            }
        })
        // console.log(itemListTemp)
        action(itemListTemp)
    }

    function setAllChoose(val) {
        console.log(val)
        var list = []
        insuranceList.map(insurance => {
            insurance.isChoose = val === 1 ? true : false
            list.push(insurance)
        })
        // console.log(list)
        setInsuranceList(list)
        setChooseAll(val === 1 ? true : false)
    }

    function setIsChoose(key, val) {

        var filterEmpty = JSON.parse(JSON.stringify(insuranceList))
        // console.log(filterEmpty)

        filterEmpty.map((insurance) => {
            if (insurance.item.caseContractor === key) {
                insurance.isChoose = val === 1 ? true : false
                // insurance.insurance = item
            }
        })
        setInsuranceList(filterEmpty)
        if (val !== chooseAll) {
            if (chooseAll) {
                setChooseAll(false)
            } else {
                var temp = filterEmpty.filter(item => {
                    return item.isChoose === false
                })
                console.log(temp.length)
                if (temp.length === 0) {
                    setChooseAll(true)
                }
            }
        }
    }
    function actionItemList(insurance) {
        // console.log(insurance)
        var filterEmpty = JSON.parse(JSON.stringify(insuranceList))

        filterEmpty.map((item) => {
            if (item.insurance.caseContractor === insurance.caseContractor) {
                item.insurance = insurance
            }
        })
        console.log(filterEmpty)
        setInsuranceList(filterEmpty)
    }
    useEffect(() => {
        // console.log(insuranceList)
    }, [insuranceList])

    useEffect(() => {
        // insuranceList.map((insurance) => (
        //     console.log(insurance)
        // ))
        var views = <>
            {insuranceList.map((insurance) => (
                <InsuranceBox key={insurance.item.caseContractor}
                isEnroll={isEnroll}
                    item={insurance}
                    isChoose={insurance.isChoose}
                    setIsChoose={setIsChoose}
                    action={actionItemList}
                    laborInsuranceLevel_Arr={laborInsuranceLevel_Arr}
                    healthInsuranceLevel_Arr={healthInsuranceLevel_Arr}
                />
            ))}
        </>
        setInsuranceListView(views)
    }, [insuranceList])

    var title = isEnroll?'待加保人員列表 - 健保加保作業':'待退保人員列表 - 健保退保作業'
    var content =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <DisableBadge count={overdueCount} text={"逾期數"} size={3} />
                    <EnableBadge count={todayCount} text={"今日數"} size={3} />
                    <div className="col-sm-6">
                        <div className="col-sm-4">
                            {isEnroll?
                            <RefuseButton name={"打勾者-不加保"} icon={"fa-minus"} action={toDel} />
                            :<></>}
                        </div>
                        <div className="col-sm-5">
                            <AddButton name={isEnroll?"打勾者-完成加保":"打勾者-完成退保"} action={toAdd} />
                        </div>
                        <div className="col-sm-3">
                            全部勾選<SingleCheckBox isCheck={chooseAll} setCheck={setAllChoose} />
                        </div>
                    </div>
                </div>
            </div>
            <Space />
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">姓名</th>
                                    <th className="text-center sorting col-sm-1">身分證號</th>
                                    <th className="text-center sorting col-sm-1">出生日</th>
                                    <th className="text-center sorting col-sm-2">級距</th>
                                    <th className="text-center sorting col-sm-1">{isEnroll?'應加保日':'應退保日'}</th>
                                    <th className="text-center sorting col-sm-1">投保統編</th>
                                    <th className="text-center sorting col-sm-2">{isEnroll?'加保日調整':'退保日調整'}</th>
                                    <th className="text-center sorting col-sm-1">狀態</th>
                                    <th className="text-center sorting col-sm-1">勾選</th>
                                </tr>
                            </thead>
                            <tbody>
                                {insuranceListView}
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        </>
    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={false} titleSize={6} />
        </>
    )
}


function InsuranceBox({ isEnroll, item, isChoose, setIsChoose, action, laborInsuranceLevel_Arr, healthInsuranceLevel_Arr }) {
    const [mInsurance, setInsurance] = useState({})
    const [name, setNmae] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [caseContractor, setCaseContractor] = useState("")
    const [laborInsuranceStatus, setLaborInsuranceStatus] = useState("")
    const [birthday, setBirthday] = useState("")
    const [enrollDate, setEnrollDate] = useState("")
    const [enrollROCDate, setEnrollROCDate] = useState("")
    const [insuredUnitGUI, setInsuredUnitGUI] = useState("")
    const [laborInsuranceType, setLaborInsuranceType] = useState("1")
    const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("")
    const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("")
    const [status, setStatus] = useState("")

    const [deateError, setDateError] = useState(false)
    // const [isChoose, setIsChoose] = useState(false)

    useEffect(() => {
        // console.log(isChoose)
    })

    useEffect(() => {
        // console.log(item)
        if (item !== undefined && Object.keys(mInsurance).length === 0) {

            setInsurance(item)
            var obj = item.item
            var insurance = item.insurance
            setNmae(obj.name)
            setIdNumber(obj.idNumber)
            setCaseContractor(obj.caseContractor)
            setLaborInsuranceStatus(obj.laborInsuranceStatus)

            setBirthday(toROCDate(obj.birthday))
            switch (parseInt(obj.dateOfInsurance)) {
                case DateOfInsuranceOnboard:
                    if (obj.caseOnBoarddays === 0) {
                        setStatus(<span className="text-info">今日</span>)
                    } else {
                        setStatus(<span className="text-danger">逾期</span>)
                    }
                    break;
                case DateOfInsuranceReserve:
                    if (obj.caseReservedays === 0) {
                        setStatus(<span className="text-info">今日</span>)
                    } else {
                        setStatus(<span className="text-danger">逾期</span>)
                    }
                    break;
                default:
                    break;
            }
            setLaborInsuranceType(obj.laborInsuranceType)
            setEnrollDate(insurance.insuranceInfo.healthInsurance.date)
            setEnrollROCDate(toROCDate(isEnroll? parseInt(obj.dateOfInsurance) === DateOfInsuranceOnboard ? item.caseOnBoardDate : item.caseReserveDate: item.caseReserveDate))
            console.log(insurance)
            setInsuredUnitGUI(insurance.insuranceInfo.insuredUnitGUI)
            setLaborInsuranceLevel(insurance.insuranceInfo.laborInsurance.level)
            setHealthInsuranceLevel(insurance.insuranceInfo.healthInsurance.level)
        }
    }, [item])

    // useEffect(() => {
    //     setEnrollROCDate(toROCDate(enrollDate))
    // }, [enrollDate])


    useEffect(() => {
        if (laborInsuranceLevel_Arr.length === 0 || laborInsuranceType === "" || laborInsuranceLevel === "")
            return
        // console.log("change")

        var laborInsuranceAmount = laborInsuranceLevel_Arr[laborInsuranceType + ""][laborInsuranceLevel - 1]
        var healthInsuranceAmount = healthInsuranceLevel_Arr[healthInsuranceLevel - 1]

        var mRespInsuranceListItem = new RespInsuranceListItem({})
        mRespInsuranceListItem.fromJson(item)
        console.log(mRespInsuranceListItem)
        mRespInsuranceListItem.insurance.insuranceInfo.insuredUnitGUI = insuredUnitGUI
        mRespInsuranceListItem.insurance.insuranceInfo.healthInsurance.date = enrollDate
        mRespInsuranceListItem.insurance.insuranceInfo.healthInsurance.level = healthInsuranceLevel
        mRespInsuranceListItem.insurance.insuranceInfo.healthInsurance.amount = healthInsuranceAmount.amount

        // console.log(mRespInsuranceListItem.insurance)
        action(mRespInsuranceListItem.insurance)
    }, [laborInsuranceLevel_Arr, enrollDate, insuredUnitGUI, laborInsuranceLevel, healthInsuranceLevel])


    function toROCDate(date) {
        var year = (moment(date).year() - 1911) + ""
        year = year.padStart(3, '0')
        return year + moment(date).format("MMDD")
    }

    function toDetail() {
        var tokenId = uuid(128, 64)
        // setVal2Token("customerPosition", { customerContractId, customerPositionId }, tokenId)
        window.location.assign("/CustomerPositionDetail/" + tokenId);
    }

    const onChangeCaseOnboardDate = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setDateError(true)
        } else {
            setDateError(false)
            setEnrollDate(dateString)
        }
    }

    function setChoose(val) {
        // console.log(val)
        setIsChoose(caseContractor, val)
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e => toDetail()}>{name}</a>&nbsp;</td>
            <td className="text-center">{idNumber}</td>
            <td className="text-center">{birthday}</td>
            <td className="text-center">
                <div className="row">
                    {isEnroll?
                    <SingleSelect
                        val={healthInsuranceLevel}
                        attr={healthInsuranceLevel_Arr}
                        action={setHealthInsuranceLevel}
                        v={"level"}
                        n={"amount"}
                        optionN={[
                            { ov: "n", on: "第" },
                            { ov: "k", on: "level" },
                            { ov: "n", on: "級" },
                            { ov: "n", on: " " },
                            { ov: "k", on: "amount" },
                            { ov: "n", on: "元" },
                        ]}
                        blankVal={"0"}
                        size={2}
                        setWidth={true}
                    // debug={true}
                    />
                    :<SingleText val={healthInsuranceLevel===""?"":healthInsuranceLevel_Arr[healthInsuranceLevel - 1].amount} /> }
                </div>
            </td>
            <td className="text-center">{enrollROCDate}</td>
            <td className="text-center">

                <input type="text" className="form-control required"
                    value={insuredUnitGUI}
                    onChange={e => setInsuredUnitGUI(e.target.value)}
                    size={8}
                />
            </td>
            <td className="text-center">
                <DatePickerInput
                    displayFormat='YYYY/MM/DD'
                    returnFormat='YYYY-MM-DD'
                    onChange={onChangeCaseOnboardDate}
                    value={enrollDate}
                    className='my-react-component'
                />
            </td>
            <td className="text-center">{status}</td>
            <td className="text-center"><SingleCheckBox isCheck={isChoose} setCheck={setChoose} /></td>
        </tr>
    )
}